import { render, staticRenderFns } from "./BookingInfo.vue?vue&type=template&id=26009ca2&"
import script from "./BookingInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./BookingInfo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports